<template>
  <v-row no-gutters class="icon-tile">
    <v-col cols="12" @mouseover="isHover = true" @mouseout="isHover = false">
      <v-row no-gutters align="center" class="icon-tile-delete-row">
        <v-spacer />
        <v-col cols="2" v-show="isHover">
          <v-icon
            @mouseover="isHover = true"
            @mouseout="isHover = false"
            size="14px"
            color="#bababa"
            @click="confirmDeleteIcon"
          >
            mdi-close
          </v-icon>
        </v-col>
      </v-row>
      <v-row no-gutters align="center" class="icon-tile-image-row">
        <v-col cols="12">
          <img width="20px" height="20px" :src="getIcon(icon.name)" class="mr-1" style="scale: 250%" />
        </v-col>
      </v-row>
      <v-row no-gutters align="center" class="icon-tile-name-row">
        <v-col cols="12">{{ icon.name }}</v-col>
      </v-row>
    </v-col>
    <main-dialog
      v-if="isConfirmDeleteIconLoaded"
      :is-visible.sync="isConfirmDeleteIconVisible"
      :title="$i18n.t('dialog.deleteIcon')"
      :body="$i18n.t('dialog.confirmIconDelete')"
      :loading="isConfirmDeleteIconLoading"
      agree-text="dialog.agreeDelete"
      @agree="deleteIconHandler"
    ></main-dialog>
  </v-row>
</template>
<script>
import { call } from 'vuex-pathify';
export default {
  name: 'IconTile',
  components: {
    MainDialog: () => import('@/components/MainDialog'),
  },
  props: {
    icon: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isConfirmDeleteIconLoading: false,
    isConfirmDeleteIconVisible: false,
    isConfirmDeleteIconLoaded: false,
    isHover: false,
  }),
  methods: {
    deleteIcon: call('layers/deleteIcon'),
    async deleteIconHandler() {
      this.isConfirmDeleteIconLoading = true;
      await this.deleteIcon(this.icon.name);
      this.$root.$emit('iconDeleted', this.icon.name);
      this.isConfirmDeleteIconLoading = false;
      this.isConfirmDeleteIconVisible = false;
      this.isConfirmDeleteIconLoaded = false;
    },
    confirmDeleteIcon() {
      this.isConfirmDeleteIconVisible = true;
      this.isConfirmDeleteIconLoaded = true;
    },
    getIcon(name) {
      return `${process.env.VUE_APP_API_URL}/icons/${name}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.icon-tile {
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  height: 75px;
}
.icon-tile-delete-row {
  height: 10%;
}
.icon-tile-image-row {
  height: 65%;
}
.icon-tile-name-row {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 16px;
  height: 25%;
}
</style>
